export default "__VITE_ASSET__3nhqLFWg__"